// import cloneDeep from 'lodash/cloneDeep';
// import pipe from '@/utils/pipe';
// import QuestionModel from '@/interfaces/reporting/question';
// import { SelectionResultGroup } from '@/interfaces/reporting/selectionResults';
import { compatibleLayouts } from '@/config/questions';
import getNormalizedValueType from '@/utils/reporting/getNormalizedValueType';
const VALUE_TYPE_COMPATIBLE_LAYOUTS = compatibleLayouts; // Intermediate data type to
// extract useful attributes
// from selection result items
// interface SelectionQuestion {
//   label: string;
//   value: any;
//   selections: string;
// }
// TODO: Deprecate?
// NOTE: Currently not in use 30/3/23
// export default function createQuestions(
//   srcSelectionGroup: SelectionResultGroup,
//   srcExistingQuestions: QuestionModel[]
// ): QuestionModel[] {
//   const results = [];
//   const selectionGroup = cloneDeep(srcSelectionGroup) as SelectionResultGroup;
//   const existingQuestions = cloneDeep(srcExistingQuestions);
//   const selectionQuestions = createSelectionQuestions(selectionGroup);
//   pipe(
//     createGenericQuestions,
//     mergeExistingQuestions
//   )({
//     results,
//     selectionQuestions,
//     existingQuestions,
//   });
//   return results;
// }
// Create generic/unconfigured questions from
// user selections from their spreadsheet
// function createGenericQuestions(config) {
//   const { results, selectionQuestions } = config;
//   selectionQuestions.forEach((selectedQuestion) => {
//     let question = null;
//     const heading = selectedQuestion.label;
//     const defaultValue = `${selectedQuestion.value}`;
//     const srcValueType = typeof selectedQuestion.value;
//     const selections = selectedQuestion.selections;
//     // Strings
//     // TODO support generic text input
//     if (srcValueType === 'string') {
//       // TODO detect select menu from original spreadsheet?
//       question = {
//         valueType: 'string',
//         layout: 'select',
//         options: `${defaultValue} | ${defaultValue}`,
//       };
//     }
//     // Numbers
//     if (srcValueType === 'number') {
//       // TODO detect select menu from original spreadsheet
//       question = { valueType: 'integer', layout: 'number' };
//     }
//     // Booleans
//     if (srcValueType === 'boolean') {
//       // TODO detect true/false select menu named values
//       // from original spreadsheet
//       question = {
//         valueType: 'boolean',
//         layout: 'select',
//         options: `true | True,false | False`,
//       };
//     }
//     // Insert question
//     if (question) {
//       results.push({
//         ...question,
//         name: '',
//         heading,
//         defaultValue,
//         selections,
//       } as QuestionModel);
//     }
//   });
//   return config;
// }
// Overwrite generic question with any
// existing configuration from the database
// function mergeExistingQuestions(config) {
//   const { results, existingQuestions } = config;
//   results.forEach((result) => {
//     // Matching configs must have same
//     // type and cell selection
//     const matchingExisting = existingQuestions.find(
//       ({ valueType, selections }) =>
//         valueType === result.valueType && selections === result.selections
//     );
//     // Overwrite generic with any
//     // matching existing config
//     if (matchingExisting) {
//       Object.assign(result, matchingExisting);
//     }
//   });
//   return config;
// }
// Extract useful data from selection result items
// DEPRECATED: no longer in use 5/3/23
// export function createSelectionQuestions(
//   selectionGroup: SelectionResultGroup
// ): SelectionQuestion[] {
//   return selectionGroup.data.map(
//     (selection) =>
//       ({
//         label: selection.label || '',
//         value: selection.value,
//         selections: `${selection.labelCell ? selection.labelCell : ''}${
//           selection.labelCell ? ':' : ''
//         }${selection.cell}`,
//       } as SelectionQuestion)
//   );
// }
// Check if a question's layout
// is valid for its' current value type

export function isValidLayoutForValueType(valueType, layout) {
  const target = getNormalizedValueType(valueType);
  const validLayouts = VALUE_TYPE_COMPATIBLE_LAYOUTS[target] || [];
  return validLayouts.includes(layout);
}